/* «Avísame»: lo poco que el formulario hace con JavaScript. Sin él funciona
   igual: el navegador avisa de lo que falta y Shopify apunta a la persona.

   1. Después de apuntarse, Shopify devuelve la página con el mensaje ya puesto
      en el sitio de los campos (`form.posted_successfully?`). El foco pasa a ese
      mensaje, para que un lector de pantalla lo diga entero; sin mover la
      página, que la coloca `assets/aru-scroll.js`. **Cuando la página ha
      terminado de cargar, no antes**: Shopify vuelve con el ancla del
      formulario (`#aru-waitlist`), y al llegar a un ancla que no se puede
      enfocar el navegador quita el foco de donde esté. Dado antes, se perdía
      (ENC-20261014-004, hallazgo 2). Si la persona ya ha movido el foco con el
      tabulador, no se le quita.
   2. Al intentar enviar con algo mal (el correo vacío o que no lo es, la casilla
      sin marcar), el navegador enseña su aviso en el primer dato que falla. Cada
      dato mal puesto se queda además marcado (`aria-invalid`, que el CSS pinta
      en rojo) hasta que se corrige: el aviso del navegador se va solo y, sin
      marca, en el iPhone no se sabía qué faltaba.
   3. De dónde llega cada alta (`T2.45`, ENC-20261019-008). Si la dirección trae
      `utm_source` (el QR del escaparate lleva `utm_source=qr`), al enviar se
      añade a las etiquetas una más, `origen-<sitio>`, y en Shopify → Clientes
      se sabe cuántas altas vienen de cada sitio. Solo valen los sitios de la
      lista de abajo; cualquier otro valor sale como `origen-otro`. Sin
      `utm_source`, o vacío, el campo no se toca. Se lee la dirección en el
      momento de enviar y no se guarda en ningún sitio (ni en el navegador ni
      en una cookie), así que no pide consentimiento: quien entra con el QR y
      pasa a otra página (o pulsa la marca) antes de apuntarse llega sin la
      etiqueta. Si las etiquetas que pinta la página ya
      traen un `origen-` (la página de contraseña lleva `origen-password`), no se
      toca nada. Sin JavaScript salen las de siempre. */
(function () {
  var form = document.querySelector('[data-aru-newsletter]');
  if (!form) return;

  var ORIGENES = ['instagram', 'tiktok', 'pinterest', 'google', 'newsletter', 'whatsapp', 'qr'];
  var etiquetas = form.querySelector('[data-aru-tags]');
  /* Las que pinta la página (en la portada, el ajuste de la sección),
     guardadas al cargar: cada envío parte de ellas, así que enviar dos veces
     no repite la etiqueta. */
  var etiquetasOriginales = etiquetas ? etiquetas.value : '';

  /* `utm_source` limpio: sin espacios a los lados, en minúsculas, cada tramo
     de lo que no sea una letra de la «a» a la «z», una cifra o un guion
     cambiado por un solo guion, y sin guiones a los lados. Vacío si no hay
     nada que apuntar. */
  function origenDeLaDireccion() {
    var valor;
    try {
      valor = new URLSearchParams(window.location.search).get('utm_source');
    } catch (e) {
      return '';
    }
    if (valor === null) return '';
    valor = String(valor).trim();
    if (!valor) return '';
    var limpio = valor.toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/^-+|-+$/g, '');
    return ORIGENES.indexOf(limpio) !== -1 ? limpio : 'otro';
  }

  /* En la fase de captura del documento: va antes que los guiones que
     escuchan el envío en el formulario o en el documento sin captura, que es
     como lo escuchan los de Shopify contra robots, así que ellos ya ven la
     etiqueta puesta. Uno que escuchara en la captura de la ventana iría antes.
     `submit` solo llega cuando el navegador ya ha dado por buenos el correo y
     la casilla.

     **Sin un origen que añadir, el campo no se toca.** Cuando Shopify pide su
     prueba contra robots, guarda lo enviado (con su `origen-qr`), devuelve la
     página (puede que sin los `utm_`) y vuelve a rellenar el campo con lo
     guardado: si aquí se devolviera el campo a las etiquetas de la página, la
     etiqueta se perdería (ENC-20261019-010, fallo 1). Y si hay que añadirla, siempre sobre
     las de la página, así que nunca sale dos veces. Si algo falla, el
     formulario se envía tal cual. */
  if (etiquetas) {
    document.addEventListener('submit', function (evento) {
      if (evento.target !== form) return;
      try {
        if (/(^|,)\s*origen-/i.test(etiquetasOriginales)) return;
        var origen = origenDeLaDireccion();
        if (!origen) return;
        var sinComaFinal = etiquetasOriginales.replace(/[\s,]+$/, '');
        etiquetas.value = (sinComaFinal ? sinComaFinal + ',' : '') + 'origen-' + origen;
      } catch (e) {
        /* Nada: el formulario sale como esté. */
      }
    }, true);
  }

  var hecho = form.querySelector('[data-aru-signup]');
  function enfocar() {
    var activo = document.activeElement;
    if (activo && activo !== document.body && activo !== document.documentElement) return;
    try { hecho.focus({ preventScroll: true }); } catch (e) { hecho.focus(); }
  }
  if (hecho && hecho.focus) {
    if (document.readyState === 'complete') enfocar();
    else window.addEventListener('load', function () { requestAnimationFrame(enfocar); });
  }

  /* `invalid` no sube por el árbol: se escucha en la fase de captura. */
  form.addEventListener('invalid', function (evento) {
    if (evento.target && evento.target.setAttribute) evento.target.setAttribute('aria-invalid', 'true');
  }, true);
  function desmarcar(evento) {
    var control = evento.target;
    if (control && control.validity && control.validity.valid) control.removeAttribute('aria-invalid');
  }
  form.addEventListener('input', desmarcar);
  form.addEventListener('change', desmarcar);
})();
